import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { CashTitle } from 'src/app/interface/cash-title';

@Component({
  selector: 'app-cant-cancel-invoice-warning',
  standalone: true,
  imports: [
    CommonModule,

    MatDialogTitle,
    MatDialogContent,
    MatDialogClose,
    MatDialogActions,
    MatButton,
    MatTableModule,
  ],
  templateUrl: './cant-cancel-invoice-warning.component.html',
  styleUrl: './cant-cancel-invoice-warning.component.scss'
})
export class CantCancelInvoiceWarningComponent {

  titles: CashTitle[];
  columns = ['titleNumber', 'clientSupplier', 'totalLows', 'value', 'balance'];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: CashTitle[]
  ) {
    if (data) {
      this.titles = data;
    }
  }
}
